import { appearFrom } from '@myre/ui-primitive-core';

import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  inject,
  Input,
  Output,
  TemplateRef,
  type AfterContentInit,
  type QueryList,
} from '@angular/core';

import { NavbarDropdownItemComponent } from './navbar-dropdown-item.component';

@Component({
  selector: 'myre-nav-dropdown',
  templateUrl: './navbar-dropdown.component.html',
  styleUrls: ['./navbar-dropdown.component.scss'],
  animations: [appearFrom(300, '30%')],
  imports: [NgTemplateOutlet, NavbarDropdownItemComponent],
})
export class NavbarDropdownComponent implements AfterContentInit {
  private _elementRef = inject(ElementRef);
  private _changeDetectorRef = inject(ChangeDetectorRef);

  @Input()
  public bordered: boolean;

  @Input()
  public template: TemplateRef<any>;

  @Input()
  public values: any[];

  @Input()
  public value: any;

  @Input()
  public icon: string = 'myre-icon-arrow_dropdown';

  @Input()
  public withValue: boolean = true;

  @Input()
  public align: 'left' | 'right' = 'right';

  @Input()
  public changeValue: boolean;

  @Input()
  public appearFrom: 'top' | 'right' = 'top';

  @Output()
  public onValueChange: EventEmitter<any> = new EventEmitter<any>();

  @HostBinding('class')
  public dropdownClass: string = 'header_text';

  @Input()
  public nbNotifs: number;

  @ContentChildren(NavbarDropdownItemComponent, { descendants: true })
  public navbarDropdownItemComponents: QueryList<NavbarDropdownItemComponent>;

  public isOpen: boolean = false;
  public ready: boolean = false;

  public ngAfterContentInit(): void {
    this._checkItems();
    this.navbarDropdownItemComponents.changes.subscribe(() =>
      this._checkItems(),
    );
  }

  public onClicked({ value }: { value: any }): void {
    if (this.changeValue) {
      this.value = value;
    }

    this.onValueChange.emit({ value });
  }

  @HostListener('document:click.out-zone', ['$event'])
  public onDocumentClick(event: Event): void {
    if (
      this.isOpen &&
      event.target instanceof Node &&
      !this._elementRef.nativeElement.contains(event.target)
    ) {
      this.toggleOpen(false);
      this._changeDetectorRef.detectChanges();
    }
  }

  @HostListener('click')
  public onClick(): void {
    this.toggleOpen();
  }

  public toggleOpen(open?: boolean | undefined): void {
    if (typeof open !== 'boolean') {
      open = !this.isOpen;
    }

    this.isOpen = open;
    this.ready = !open;
  }

  private _checkItems(): void {
    setTimeout(() => {
      for (let i = 0; i < this.navbarDropdownItemComponents.length; i++) {
        const elt = this.navbarDropdownItemComponents.toArray()[i];
        elt.isFirst = i === 0;
      }
    });
  }
}
